/**
 * Azure resource template deployment operation.
 * A resource deployment operation is potentially an asynchronous operation.
 * Read https://docs.microsoft.com/en-us/azure/azure-resource-manager/resource-manager-async-operations
 * for how to track asynchronous Azure operations.
 */
export interface DeploymentOperationResponse {
    /**
     * The http status code.
     */
    httpStatusCode: number;

    /**
     * The response headers to track asynchronous operations.
     */
    responseHeaders?: Map<string, string>;

    /**
     * The response object.
     */
    response?: any;
}
